import * as React from "react"; 
import { useState, useEffect } from "react";
import Modal from "../core/Modal";
import Button from "../core/Button";
import { jfetch, toast } from "../../utils";


function SettingsModal(props){

  const [showModal, setShowModal] = useState(false)
  const [loading, setLoading] = useState(false)
  const [showHomepage, setShowHomepage] = useState('false')
  const [showLogin, setShowLogin] = useState('false')
  const [registerUrl, setRegisterUrl] = useState('')
  const [countdownDate, setCountdownDate] = useState('')
  const [newEvent, setNewEvent] = useState('')
    // [{title:'q&a', id:2},{}]
  const [events, setEvents] = useState([])
  const [maxID, setMaxID] = useState(0)
  const [zoomLive, setZoomLive] = useState('')
  const [scheduleLive, setScheduleLive] = useState('')
  const [curEvent, setCurEvent] = useState('')
  const [showProducts, setShowProducts] = useState('false')
  const [listSearch, setListSearch] = useState('academy')
  const [lists, setLists] = useState([])
  const [myList, setMyList] = useState('')

  useEffect(() => {
    jfetch.get('/global_settings/show').then((resp) => {
      // setValue(resp.setting.intro_text)
      setShowProducts(resp.setting.show_products)
      if(resp.setting.register_homepage != null){
        setShowHomepage(resp.setting.register_homepage)
      }
      if(resp.setting.register_login != null){
        setShowLogin(resp.setting.register_login)
      }
      if(resp.setting.register_url != null){
        setRegisterUrl(resp.setting.register_url)
      }
      if(resp.setting.countdown_date != null){
        setCountdownDate(resp.setting.countdown_date)
      }
      if(resp.setting.zoom_events != null){
        setEvents(resp.setting.zoom_events)
        if(resp.setting.zoom_events.length > 0){
          let max = 0
          resp.setting.zoom_events.forEach(event => {
            if(event.id > max){
              max = event.id
            }
          });
          setMaxID(max)
        }
      }
    })
    getAPI()
  }, [])

  useEffect(() => {
    jfetch.get(`/ac/lists/search`, {q: listSearch}).then((resp) => {
      setLists(resp.result.lists)
    })
  }, [listSearch])

  useEffect(() => {
    fetch('https://api.chartec.net/v2/academy/list?id=asd6yb5i465l339j0s0j033ksdiwDaaa')
    .then((response) => response.json())
    .then((data) => {
      setMyList(data.ac_listid)
    })
  }, [])

  async function updateModal(){
    const data = {
      global_setting:{
        register_homepage: showHomepage,
        register_login: showLogin,
        register_url: registerUrl,
        countdown_date: countdownDate,
        zoom_events: events,
        show_products: showProducts
      }
    }
    await jfetch.patch('/global_settings/update', data)
    await updateAPI()
    setShowModal(false)
    toast.success('Settings were Saved!')
  }

  async function addEvent(){
    let e = [...events]
    const newID = maxID+1
    e.push({id:newID, title:newEvent})
    setEvents(e)
    setMaxID(newID)
    setNewEvent('')
  }

  async function getAPI(){
    let resp = await fetch(`https://api.chartec.net/v2/core/global_settings/zoom_button_settings`, {
      method: 'GET', 
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Authorization': props.v2_token
      }
    })
    let json = await resp.json();
    let settings = JSON.parse(json[0].json)
    setZoomLive(settings.zoom_live)
    setCurEvent(settings.current_event)
    setScheduleLive(settings.schedule_live)
  }

  async function updateAPI(){
    let resp = await fetch(`https://api.chartec.net/v2/core/global_settings/zoom_button_settings`, {
      method: 'POST', 
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Authorization': props.v2_token
      },
      body: JSON.stringify({current_event:curEvent, zoom_live:zoomLive, schedule_live:scheduleLive})
    })
  }

  function destroyEvent(){
    let e = [...events]
    e.pop()
    setEvents(e)
  }

  function toggleList(list_id){
    setMyList(list_id)
    fetch(`https://api.chartec.net/v2/academy/list?id=asd6yb5i465l339j0s0j033ksdiwDaaa`, {
      method: 'POST', 
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Authorization': props.v2_token
      },
      body: JSON.stringify({id:list_id})
    })
  }


  return(
    <div className="intro-modal-edit">
      <a onClick={() => setShowModal(true)} style={{cursor:'pointer'}}> 
        CORE Settings
      </a>
      <Modal
        title="CORE Settings Modal Editor"
        open={showModal}
        close={() => setShowModal(false)}
        submittable={true}
        isLarge={true}
        disallowClickOutside={true}
        submitText="Save"
        onSubmit={updateModal}
      >
        <div className="container-fluid" style={{margin:'0px'}}>
          <div className="row settingrow">
            <div className="col-lg-4">
              <label>Show "Register Now" 1 Click Button for Academy:</label>
            </div>
            <div className="col-lg-4">
              <select style={{height:'30px'}} value={showHomepage} onChange={(e) => setShowHomepage(e.target.value)}>
                <option value="true">yes</option>
                <option value="false">no</option>
              </select>
            </div>
          </div>
          <div className="row settingrow">
            <div className="col-lg-4">
              <label>Show login register link:</label>
            </div>
            <div className="col-lg-4">
              <select style={{height:'30px'}} value={showLogin} onChange={(e) => setShowLogin(e.target.value)}>
                <option value="true">yes</option>
                <option value="false">no</option>
              </select>
            </div>
          </div>
          <div className="row settingrow">
            <div className="col-lg-4">
              <label>Login Link URL:</label>
            </div>
            <div className="col-lg-4">
              <input value={registerUrl} type="text" className="form-control" onChange={(e) => setRegisterUrl(e.target.value)} />
            </div>
          </div> 
          <div className="row settingrow">
            <div className="col-lg-4">
              <label>Countdown Date:</label>
            </div>
            <div className="col-lg-4">
              <input value={countdownDate} type="text" className="form-control" onChange={(e) => setCountdownDate(e.target.value)}/>
            </div>
          </div>
          <div className="row settingrow">
            <div className="col-lg-4">
              <label>Zoom Events ({events.length}):</label>
            </div>
            <div className="col-lg-4">
              <input value={newEvent} type="text" className="form-control" onChange={(e) => setNewEvent(e.target.value)} />
            </div>
            <div className="col-lg-4">
              <div style={{marginRight:'10px', display:'inline-flex'}}>
                <Button color="primary" onClick={addEvent}>Add Event</Button>
              </div>
              <Button color="danger" onClick={destroyEvent}>Remove Event</Button>
            </div>
          </div>
          <div className="row settingrow">
            <div className="col-lg-4">
            </div>
            <div className="col-lg-8">
              {events.map((event) => {
                return <span key={event.id} style={{backgroundColor:'#3bce95', color:'white', padding:'5px 8px', marginRight:'10px'}}>{event.title}</span>
              })}
            </div>
          </div>
          <div className="row settingrow">
            <div className="col-lg-4">
              <label>Zoom Is Live:</label>
            </div>
            <div className="col-lg-4">
              <select style={{height:'30px'}} value={zoomLive} onChange={(e) => setZoomLive(e.target.value)}>
                <option value="true">yes</option>
                <option value="false">no</option>
              </select>
            </div>
          </div>
          <div className="row settingrow">
            <div className="col-lg-4">
              <label>Current Zoom Event:</label>
            </div>
            <div className="col-lg-4">
              <select style={{height:'30px'}} value={curEvent} onChange={(e) => setCurEvent(e.target.value)}>
                <option value=''>None Selected</option>
                {events.map((event) => {
                  return <option key={event.id} value={event.id}>{event.title}</option>
                })}
              </select>
            </div>
          </div>
          <div className="row settingrow">
            <div className="col-lg-4">
              <label>Events Schedule Is Live:</label>
            </div>
            <div className="col-lg-4">
              <select style={{height:'30px'}} value={scheduleLive} onChange={(e) => setScheduleLive(e.target.value)}>
                <option value="true">yes</option>
                <option value="false">no</option>
              </select>
            </div>
          </div>          
          <div className="row settingrow">
            <div className="col-lg-4">
              <label>Products In Side Menu:</label>
            </div>
            <div className="col-lg-4">
              <select style={{height:'30px'}} value={showProducts} onChange={(e) => setShowProducts(e.target.value)}>
                <option value="true">yes</option>
                <option value="false">no</option>
              </select>
            </div>
          </div>
          <div className="row settingrow">
            <div className="col-lg-4">
              <label>"Register now" AC List:</label>
            </div>
            <div className="col-lg-4">
              <input value={listSearch} type="text" className="form-control" onChange={(e) =>  setListSearch(e.target.value)} />
              <select style={{height:'30px'}} value={myList} onChange={(e) => toggleList(e.target.value)}>
                <option value="">Select One</option>
                {lists.map((list) => {
                  return <option value={list.id} key={list.id}>{list.name}</option> 
                })}
              </select>
            </div>
          </div>             
        </div>
      </Modal>
    </div>
  )
}

export default SettingsModal


// WEBPACK FOOTER //
// ./app/javascript/components/pages/SettingsModal.tsx